import React from 'react';
import { Link } from 'react-router-dom';
import { Flex, Box, Button } from '@mantine/core';
import { HamburgerMenu } from './partials/HamburgerMenu';
import { LanguageSelect } from './partials/LanguageSelect';
import { useAuth } from '@/providers/AuthProvider';
import LogoSrc from '@/assets/images/logo.svg';
import styles from './Navbar.module.scss';

const baseSlug = 'sidebar.';

export const Navbar: React.FC = () => {
	const { user, admin, logout } = useAuth();

	return (
		<Box
			component="nav"
			id="navbar"
			className={styles.navbar}
			px={{ base: 'md', md: 'lg' }}
		>
			<Box>
				<Link to="/">
					<img src={LogoSrc} />
				</Link>
			</Box>
			<Flex gap="lg">
				{admin ? (
					<Button onClick={logout}>Wyloguj z admina</Button>
				) : (
					<LanguageSelect />
				)}
				{!!user && <HamburgerMenu baseSlug={baseSlug} />}
			</Flex>
		</Box>
	);
};
